/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InsurancePeriod } from './insurancePeriod';
import { PreviousPrivateLiabilityInsurance } from './previousPrivateLiabilityInsurance';
import { PreviousMotorVehicleProduct } from './previousMotorVehicleProduct';
import { PreviousPrivateLiabilityProduct } from './previousPrivateLiabilityProduct';

/**
 * @type PreviousProduct
 * @export
 */
export type PreviousProduct = PreviousMotorVehicleProduct | PreviousPrivateLiabilityProduct;
